const a2dAuth = process.env.VUE_APP_A2DAUTH
const mapBoxToken = process.env.VUE_APP_MAPBOX

const config = {
  mapBoxToken: mapBoxToken,
  a2dAuth: a2dAuth
};

export default config